import { approvalsCommand } from "@/commands/command/approvals-command";
import { catalogCommand } from "@/commands/command/catalog-command";
import { helpCommand } from "@/commands/command/help-command";
import { keysCommand } from "@/commands/command/keys-command";
import { loginCommand } from "@/commands/command/login-command";
import { logoutCommand } from "@/commands/command/logout-command";
import { questionsCommand } from "@/commands/command/questions-command";
import { runCommand } from "@/commands/command/run-command";
import { sessionsCommand } from "@/commands/command/sessions-command";
import { whoamiCommand } from "@/commands/command/whoami-command";
import { args } from "@/lib/args/args";
import { CliError } from "@/lib/cli/cli-error";
import { CATALOG_TOPICS } from "@/catalog-topics-constants";
export async function dispatch(command: string, argv: string[]): Promise<void> {
  const parsed = args.parse(argv);

  if (parsed.booleans.has("help")) {
    helpCommand();
    return;
  }

  if (CATALOG_TOPICS.has(command)) {
    return await catalogCommand(command, parsed);
  }

  switch (command) {
    case "login":
      return await loginCommand(parsed);
    case "logout":
      return logoutCommand(parsed);
    case "whoami":
      return await whoamiCommand(parsed);
    case "keys":
      return await keysCommand(parsed);
    case "run":
      return await runCommand(parsed);
    case "sessions":
      return await sessionsCommand(parsed);
    case "questions":
      return await questionsCommand(parsed);
    case "approvals":
      return await approvalsCommand(parsed);
    default:
      helpCommand();
      throw new CliError(`Unknown command "${command}".`, 2);
  }
}
